import Parseable from '@/misc/Parseable';
import Company from '@/models/Company';
import Ride from '@/models/Ride';
import BillingDetails from '@/models/BillingDetails';

export default class Billing extends Parseable {
    public id!: string;
    public company!: Company;
    public rides: Ride[] = [];

    public billingDetails!: BillingDetails;

    public static parseFromObject(object: Partial<Billing>): Billing {
        const billing = new Billing();
        Object.assign(billing, object);

        if (object.company) {
            billing.company = Company.parseFromObject(object.company);
        }

        if (object.rides) {
            billing.rides = Ride.parseFromArray(object.rides) as Ride[];
        }

        billing.billingDetails = new BillingDetails(billing.rides);

        return billing;
    }

    public parseToObject(): Partial<Billing> {
        return { ...this };
    }
}
